import React, { useState, useEffect, Fragment, Suspense } from "react";
import { Route, Redirect } from "react-router-dom";
import { CoverLetterProvider } from "../context/CoverLetterContext";
import WpAPI from "../WpApi";
import { 
  COVERLETTER_LANDINGPAGE,
  COVERLETTER_CHOOSE_TEMPLATE, 
  COVERLETTER_EXPERIENCE, 
  COVERLETTER_EXP_WORKHISTORY, 
  COVERLETTER_FINALIZE, 
  COVERLETTER_CUSTOMIZE, 
  COVERLETTER_LOGIN, 
  COVERLETTER_PERSONALIZE, 
  COVERLETTER_SKILLS,
  COVERLETTER_STRENGTH, 
  COVERLETTER_WORKSTYLE, 
  COVERLETTER_JOBDETAILS,
  DASHBOARD_LINK
} from "../constants/constants";
import Footer from "./common/Footer";
import ChooseTemplate from "./coverletter/ChooseTemplate";
import SimpleHeader from "./common/SimpleHeader";
import PageLoader from "./common/PageLoader";
import Experience from "./coverletter/Experience";
import Skills from "./coverletter/Skills";
import Strengths from "./coverletter/Strengths";
import WorkStyle from "./coverletter/WorkStyle";
import WorkHistory from "./coverletter/WorkHistory";
import Personalize from "./coverletter/Personalize";
import JobDetails from "./coverletter/JobDetails";
import Login from "./coverletter/Login";
import Finalize from "./coverletter/Finalize";
import LandingPage from "./coverletter/LandingPage";
import Customize from "./coverletter/Customize";

const CoverLetter = (props)=> {
    const [redirect, setRedirect] = useState(false);
    // const [currentLetter, setCurrentLetter] = useState('');

    useEffect(() => {
        // if (currentLetter === '') {
        //   let cr = WpAPI.getCurrentLetter();
        //   setCurrentLetter(cr);
        // }
      },[]);
    if (redirect) return <Redirect to={DASHBOARD_LINK} />

    return (<>
    {/* props.currentLetter != undefined && */}
        {  <CoverLetterProvider {...props}>
          <Fragment>
             <Route path={`${COVERLETTER_CHOOSE_TEMPLATE}:exp?`}>
             <SimpleHeader />
              <div className="template-selector-screen">
                <Suspense fallback={<PageLoader />}>
                  <ChooseTemplate />
                </Suspense>
              </div>
              {/* <Layout
                left={<EditorSectionsTips splash={<Splash />}  section={'work_history'}  nextSection={WORKHISTORY_LINK} previousSection={HEADING_LINK}/>}
                right={<RightSection current_tab={props.current_tab} resume={props.resume} />}
                showLoginPopUp={showLoginPopUp}
                setShowLoginPopUp={(showLoginPopUp) => { setShowLoginPopUp(showLoginPopUp) }}
                breadcrumb={!props.resume.enabled_tabs.includes('completed') ? <BreadcrumComponent enabled={props.resume.enabled_tabs} /> : false}
              /> */}
            </Route>
            <Route exact path={COVERLETTER_LOGIN}>
             <SimpleHeader />
              <Login />
            </Route>
            <Route exact path={COVERLETTER_CUSTOMIZE}>
             <SimpleHeader />
              <Customize />
            </Route>
            <Route exact path={COVERLETTER_JOBDETAILS}>
             <SimpleHeader />
              <JobDetails />
            </Route>
            <Route exact path={COVERLETTER_EXPERIENCE}>
             <SimpleHeader />
              <Experience />
            </Route>
            <Route exact path={COVERLETTER_SKILLS}>
             <SimpleHeader />
              <Skills />
            </Route>
            <Route exact path={COVERLETTER_STRENGTH}>
             <SimpleHeader />
              <Strengths />
            </Route>
            <Route exact path={COVERLETTER_WORKSTYLE}>
             <SimpleHeader />
              <WorkStyle />
            </Route>
            <Route exact path={COVERLETTER_EXP_WORKHISTORY}>
             <SimpleHeader />
              <WorkHistory />
            </Route>
            
            
            <Route exact path={COVERLETTER_FINALIZE}>
             <SimpleHeader />
              <Finalize />
              {/* <Layout
                left={<EditorSectionsTips splash={<Splash />}  section={'work_history'}  nextSection={WORKHISTORY_LINK} previousSection={HEADING_LINK}/>}
                right={<RightSection current_tab={props.current_tab} resume={props.resume} />}
                showLoginPopUp={showLoginPopUp}
                setShowLoginPopUp={(showLoginPopUp) => { setShowLoginPopUp(showLoginPopUp) }}
                breadcrumb={!props.resume.enabled_tabs.includes('completed') ? <BreadcrumComponent enabled={props.resume.enabled_tabs} /> : false}
              /> */}
            </Route>
            <Route exact path={COVERLETTER_PERSONALIZE}>
             <SimpleHeader />
              <Personalize />
            </Route>
            <Route exact path={COVERLETTER_LANDINGPAGE}>
             <SimpleHeader />
              <LandingPage />
            </Route>
            <Footer />
          </Fragment>
        </CoverLetterProvider>}
      </>);

};
export default CoverLetter;